import AuthStorage from "../utils/AuthStorage";
import { fetchApi } from "../utils/fetch-api";

export class settingsApi {
    static async hideUsername(otp) {
        const headers = {};
        try {
            const data = fetchApi({
                url: `/api/v1/profile/hide-username?otp=${otp}`,
                options: {
                    method: "GET",
                    headers,
                },
            },
                (err, response) => {
                    if (err) return;
                    if (response.status !== true) return;
                    if (response?.data) {
                        const [addr1, addr2, addr3] =
                            response?.data?.wallets?.pulsar_data?._addresses?.reverse();
                        const balance = response?.data?.wallets?.pulsar_data?.balance;
                        AuthStorage.value = {
                            token: response?.data?.token,
                            user: response?.data?.user,
                            wallets: {
                                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
                            }, // address order is important
                        };
                    }
                }
            );
            return data;
        } catch (error) {
            throw error;
        }
    }

    static async showUsername(otp) {
        const headers = {};
        try {
            const data = fetchApi({
                url: `/api/v1/profile/show-username?otp=${otp}`,
                options: {
                    method: "GET",
                    headers,
                },
            },
                (err, response) => {
                    if (err) return;
                    if (response.status !== true) return;
                    if (response?.data) {
                        const [addr1, addr2, addr3] =
                            response?.data?.wallets?.pulsar_data?._addresses?.reverse();
                        const balance = response?.data?.wallets?.pulsar_data?.balance;
                        AuthStorage.value = {
                            token: response?.data?.token,
                            user: response?.data?.user,
                            wallets: {
                                pulsar_data: { _addresses: [addr3, addr2, addr1], balance },
                            }, // address order is important
                        };
                    }
                }
            );
            return data;
        } catch (error) {
            throw error;
        }
    }


    static async transferAllCoins(payload) {
        const headers = {};
        try {
            const data = fetchApi({
                url: '/api/v1/profile/transfer-coin-ownership',
                options: {
                    method: "POST",
                    headers,
                },
                payload
            }
            );
            return data;
        } catch (error) {
            throw error;
        }
    }

    static async deleteAccount(otp) {
        const headers = {};
        try {
            const data = fetchApi({
                url: `/api/v1/profile/delete-account?otp=${otp}`,
                options: {
                    method: "DELETE",
                    headers,
                },
            },
            );
            return data;
        } catch (error) {
            throw error;
        }
    }

}